module.exports = [
	{
		"componentChunkName": "page-component---src-pages-404-js",
		"jsonName": "404.json",
		"path": "/404/"
	},
	{
		"componentChunkName": "page-component---src-pages-index-js",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "page-component---src-pages-tos-js",
		"jsonName": "tos.json",
		"path": "/tos/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-js",
		"jsonName": "404-html.json",
		"path": "/404.html"
	},
	{
		"componentChunkName": "page-component---src-pages-work-aquarisk-js",
		"jsonName": "work-aquarisk.json",
		"path": "/work/aquarisk/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-betasmartz-js",
		"jsonName": "work-betasmartz.json",
		"path": "/work/betasmartz/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-blacklight-js",
		"jsonName": "work-blacklight.json",
		"path": "/work/blacklight/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-buddybet-js",
		"jsonName": "work-buddybet.json",
		"path": "/work/buddybet/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-linguaphone-js",
		"jsonName": "work-linguaphone.json",
		"path": "/work/linguaphone/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-llanoseco-js",
		"jsonName": "work-llanoseco.json",
		"path": "/work/llanoseco/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-macau-news-js",
		"jsonName": "work-macau-news.json",
		"path": "/work/macau-news/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-pesposa-js",
		"jsonName": "work-pesposa.json",
		"path": "/work/pesposa/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-pingusenglish-js",
		"jsonName": "work-pingusenglish.json",
		"path": "/work/pingusenglish/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-spindal-js",
		"jsonName": "work-spindal.json",
		"path": "/work/spindal/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-upwork-js",
		"jsonName": "work-upwork.json",
		"path": "/work/upwork/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-vands-js",
		"jsonName": "work-vands.json",
		"path": "/work/vands/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-wisense-js",
		"jsonName": "work-wisense.json",
		"path": "/work/wisense/"
	},
	{
		"componentChunkName": "page-component---src-pages-work-witsbits-js",
		"jsonName": "work-witsbits.json",
		"path": "/work/witsbits/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 37